export interface LoadingState {
  isImportLoading: boolean
  isAuditSubmitButtonLoading: boolean
}
interface State {
  currentStep: number
  formData: any
  loadingState: LoadingState
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setCurrentStepAction'
  | 'setLoadingStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  currentStep: 0,
  formData: {},
  loadingState: {
    isImportLoading: false,
    isAuditSubmitButtonLoading: false,
  },
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setCurrentStepAction':
      newstate.currentStep = action.payload
      return newstate
    case 'setLoadingStateAction':
      newstate.loadingState = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('throw no match action')
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setCurrentStepAction = (val: number): Action => ({
  type: 'setCurrentStepAction',
  payload: val,
})

export const setLoadingStateAction = (val: LoadingState): Action => ({
  type: 'setLoadingStateAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
export interface LoadingState {
  isImportLoading: boolean
  isAuditSubmitButtonLoading: boolean
}
interface State {
  currentStep: number
  formData: any
  loadingState: LoadingState
}
type ActionType =
  | 'setFormDataAction'
  | 'resetStateAction'
  | 'setCurrentStepAction'
  | 'setLoadingStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  currentStep: 0,
  formData: {},
  loadingState: {
    isImportLoading: false,
    isAuditSubmitButtonLoading: false,
  },
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setCurrentStepAction':
      newstate.currentStep = action.payload
      return newstate
    case 'setLoadingStateAction':
      newstate.loadingState = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('throw no match action')
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setCurrentStepAction = (val: number): Action => ({
  type: 'setCurrentStepAction',
  payload: val,
})

export const setLoadingStateAction = (val: LoadingState): Action => ({
  type: 'setLoadingStateAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
